module.exports = __webpack_public_path__ + "img/hospitality-section22.09da0364.svg";